module.exports = __webpack_public_path__ + "img/VocabularyPageThumbnail.f4360c1f.png";